__turbopack_context__.v({
  "notice-button": "marketplace-ufb-notice-module-scss-module__DTIUga__notice-button",
  "notice-container": "marketplace-ufb-notice-module-scss-module__DTIUga__notice-container",
});
